import { useSyncExternalStore, useEffect } from "react";
import { useLocation } from "wouter";
import { useAppStore } from "@/store";

function useStoreHydrated() {
  return useSyncExternalStore(
    useAppStore.persist.onFinishHydration,
    () => useAppStore.persist.hasHydrated(),
    () => false
  );
}

export default function StartPage() {
  const hydrated = useStoreHydrated();
  const { authToken, startOnboarding } = useAppStore();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!hydrated) return;

    if (authToken) {
      setLocation("/", { replace: true });
      return;
    }

    startOnboarding();
    setLocation("/", { replace: true });
  }, [hydrated, authToken, startOnboarding, setLocation]);

  return (
    <div className="min-h-screen bg-[#0D1A2A] flex items-center justify-center">
      <div className="w-6 h-6 rounded-full border-2 border-cyan-500 border-t-transparent animate-spin" />
    </div>
  );
}
